import { OtherRate, otherRateNames } from 'common/models/settings/otherRates';
import currency from 'currency.js';
import { useMemo, useState } from 'react';
import { Column } from 'react-table';
import {
  CenteredHeader,
  CenteredText,
} from '../components/Sub-views/RatesView/Tabs/styles';
import {
  RateFormProps,
  TableRateInput,
} from '../components/Sub-views/RatesView/Tabs/TableRateInput';

export type OtherRateRow = {
  type: string;
  rate: RateFormProps;
};

export const useOtherRatesTableData = (
  rows: OtherRate[],
  isSubmitting: boolean,
): {
  columns: Column<OtherRateRow>[];
  data: OtherRateRow[];
  isEditing: boolean;
  setIsEditing: (isEditing: boolean) => void;
} => {
  const [isEditing, setIsEditing] = useState(false);

  const columns: Column<OtherRateRow>[] = useMemo(
    () => [
      {
        Header: () => <CenteredHeader>Description</CenteredHeader>,
        accessor: 'type',
        width: '50%',
        Cell: ({ value }) => <CenteredText>{value}</CenteredText>,
      },
      {
        Header: () => <CenteredHeader>Rate</CenteredHeader>,
        accessor: 'rate',
        width: '50%',
        Cell: ({ value }) => (
          <TableRateInput
            showInput={isEditing}
            value={value}
            isSubmitting={isSubmitting}
          />
        ),
      },
    ],
    [isEditing, isSubmitting],
  );

  const data: OtherRateRow[] = useMemo(
    () =>
      rows.map(({ id, type, rate }) => ({
        type: otherRateNames[type],
        rate: {
          formValueKey: id.toString(),
          displayValue: currency(rate).format(),
        },
      })),
    [rows],
  );

  return {
    columns,
    data,
    isEditing,
    setIsEditing,
  };
};
